/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Role } from '../../models/role';

export interface DeleteRole$Params {
  roleName: string;
}

export function deleteRole(http: HttpClient, rootUrl: string, params: DeleteRole$Params, context?: HttpContext): Observable<StrictHttpResponse<Role>> {
  const rb = new RequestBuilder(rootUrl, deleteRole.PATH, 'delete');
  if (params) {
    rb.path('roleName', params.roleName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Role>;
    })
  );
}

deleteRole.PATH = '/api/role/name/{roleName}';
